/* Sns Schema Module */
import { code } from '@/libs/schema/schema';
import { z } from 'zod';
import { AuthConstantS, AuthSchemaS } from '../../Auth/outbound/share';
import { CertificationConstantS } from '../../Certification/outbound/share';

export const SNS_TYPE_ENUM = z.nativeEnum(AuthConstantS.USER_LOGIN_SNS_TYPE_MAPPER);

export const SnsConnectDeleteControllerReqBody = z.object({
  sns_type: SNS_TYPE_ENUM,
});

export const SnsConnectControllerReqBody = z
  .object({
    code: code.optional(),

    /**
     * 인증 타입
     * @example RESET_PW
     * */
    certification_type: z.nativeEnum(CertificationConstantS.CERTIFICATION_TYPE).optional(),
  })
  .merge(AuthSchemaS.SigninControllerReqBody);
